/** =========================================================
 * Module: items-custom-buttons.directive.js
 * Item custom buttons
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemCustomButtons', itemCustomButtons);

  itemCustomButtons.$inject = [];

  function itemCustomButtons() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/item-custom-buttons.html',
      link: link,
      scope: {
        config: '=',
        item: '=',
        stack: '@'
      }
    };

    return directive;

    function link($scope) {
      $scope.data = $scope.config && $scope.config.hasOwnProperty($scope.stack) ? $scope.config[$scope.stack] : [];

      $scope.tryFunction = function (item, field, fieldItem) {
        try {
          return typeof field[fieldItem] === 'function' ? field[fieldItem](item) : field[fieldItem];
        } catch (error) {
          Raven.captureException(error);
        }

        return '';
      };
    }
  }
})();
